<aura-edit-wrapper
  title="Visibilité & Confidentialité du profil"
  [(isEditing)]="isEditing"
  [isAllowedToEdit]="isAllowedToEdit()"
  [showDivider]="true"
  (saved)="onSave($event)"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing()) {
    <etxe-agent-visibility-form
      [settings]="currentSettings()"
      (validityChanged)="editWrapper.onValidityChanged($event)"
      (dtoChanged)="editWrapper.onDtoChanged($event)"
    />
  } @else {
    <etxe-agent-visibility-display [settings]="currentSettings()" [agentProfileId]="initialProfile()?._id" />
  }
</aura-edit-wrapper>
